/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Aggregation } from './aggregation';
import { TimeSeriesData } from './timeSeriesData';


export interface TimeSeriesDataResponse { 
    start?: string;
    stop?: string;
    format?: string;
    aggregation?: Aggregation;
    data?: TimeSeriesData;
    serial_number?: string;
}

